<template>
  <div v-show="visible" class="loading-wrap" onselectstart="return false">
    <div class="loading-box">
      <img
        ref="img"
        class="rotateImages"
        :src="`${$publickCdn}static/broadcast/img/live_loading.png`"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true,
    }
  },
}
</script>
<style lang="less" scoped>
.loading-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: transparent;
  z-index: 100;
  -moz-user-select: none;
}
.loading-box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto;
  transform: translate(-50%, -50%);
}
.rotateImages {
  width: 36px;
  height: 36px;
}
.loading-box img.rotateImages {
  -webkit-animation: myRotate 0.8s linear infinite;
  animation: myRotate 0.8s linear infinite;
}
@-webkit-keyframes myRotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes myRotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>